///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2025
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

export const tlColumnConstants = {
  LANE_HAS_MATCHES: "hasMatches",
  SHIPPER_LANE_ID: "shipperLaneId",
  TOTAL_RATE: "totalRate",
  RATE_PER_UNIT: "ratePerMile",
  FLAT_RATE: "flatRate",
  BASE_RATE_PER_UNIT: "baseRatePerMile",
  FUEL_RATE: "fuelRate",
  ORIGIN_CITY: "originCity",
  ORIGIN_STATE: "originState",
  ORIGIN_POSTAL_CODE: "originPostalCode",
  ORIGIN_COUNTRY: "originCountry",
  DESTINATION_CITY: "destinationCity",
  DESTINATION_STATE: "destinationState",
  DESTINATION_POSTAL_CODE: "destinationPostalCode",
  DESTINATION_COUNTRY: "destinationCountry",
  EQUIPMENT_TYPE: "equipmentType",
  SHIPPER_DISTANCE: "shipperMiles",
  COYOTE_DISTANCE: "coyoteMiles",
  TTT_COST: "tttCost",
  PREVIOUS_TTT_COST: "previousTTTCost",
  PRICING_MODEL: "pricingModel",
  COST_PER_UNIT: "costPerMile",
  TOTAL_COST: "totalCost",
  MARGIN: "margin",
  MARGIN_PERCENTAGE: "marginPercentage",
  REGION: "region",
  VOLUME: "volume",
  ADDITIONAL_FEE: "additionalFee",
  ORIGIN_NOTE: "originNote",
  DESTINATION_NOTE: "destinationNote",
  BID_NOTE: "bidNote",
  LAST_EDITED_USER_NAME: "lastEditedUserName",
  EDITED: "edited",
  HAZMAT: "hazmat",
  ORIGIN_DROP_TRAILER: "originDropTrailer",
  DESTINATION_DROP_TRAILER: "destinationDropTrailer",
  PERMIT: "permit",
  TEAM: "team",
  HRHV: "hrhv",
  TARGET_RATE: "targetRate",
  MINIMUM_RATE: "minimumRate",
  CAPACITY_SOURCE: "capacitySource",
  INCUMBENT_RATE: "incumbentRate",
  FUEL_SURCHARGE: "fuelSurcharge",
  AWARD_RATE: "awardRate",
  AWARD_TYPE: "awardType",
  AWARD_VOLUME: "awardVolume",
  AWARD_RANK: "awardRank",
  FUEL_SURCHARGE_TYPE: "fuelSurchargeType",
  MX_COST: "mxCost",
  BORDER_CROSSING_FEE: "borderCrossingFee",
  TRANSLOAD_FEE: "transloadFee",
  BID_START_DATE: "startDateUTC",
  BID_END_DATE: "endDateUTC",
  SHIPPER_NAME: "shipperName",
  BID_NAME: "bidName",
  BID_STATUS: "bidStatus",
  MX_MILES: "mxMiles",
  BORDER_CROSSING_CITY: "borderCrossingCity",
  BORDER_CROSSING_STATE: "borderCrossingState",
  BORDER_CROSSING_COUNTRY: "borderCrossingCountry",
  PRICING_CONFIDENCE: "pricingConfidence",
  STRATEGIC_PERIOD_TTT_COST: "strategicTTTCost",
  STRATEGIC_QUANTILE_TTT_COST: "strategicQuantileTTTCost",
  STRATEGIC_QUANTILE: "strategicQuantile",
  RATE_TYPE: "rateType",
  ROUND_TRIP: "roundTrip",
  MULTI_STOP: "multiStop",
  EQUIPMENT_TYPE_DETAIL: "equipmentTypeDetail",
  TARGET: "target",
  TARGET_TYPE: "targetType",
  CUSTOMER_FEEDBACK_TYPE: "customerFeedbackType",
  CUSTOMER_FEEDBACK: "customerFeedback",
  PWB_COST: "pwbCost",
  RXO_USA_TTT_COST: "rxousatttCost",
  PWB_MARGIN: "pwbMargin",
  TRUCKLOAD_LANE_ID: "truckloadLaneId"
};

export default tlColumnConstants;
